import { render, staticRenderFns } from "./competitive.vue?vue&type=template&id=0b33b3ce&"
import script from "./competitive.vue?vue&type=script&lang=js&"
export * from "./competitive.vue?vue&type=script&lang=js&"
import style0 from "./competitive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports